export default "__VITE_ASSET__BbhBaXqv__"